import { transformSchemaDefinition } from "../transform.js";
function getAllOfSchemas(schema) {
    const result = [];
    const stack = [schema];
    while (stack.length > 0) {
        const current = stack.pop();
        if (typeof current === "boolean" || current.allOf === undefined) {
            result.push(current);
            continue;
        }
        const { allOf, ...rest } = current;
        result.push(rest);
        for (let i = allOf.length - 1; i >= 0; i--) {
            stack.push(allOf[i]);
        }
    }
    return result;
}
export function createShallowAllOfMerge(mergeArrayOfSchemaDefinitions) {
    return (schema) => mergeArrayOfSchemaDefinitions(getAllOfSchemas(schema));
}
export function createDeepAllOfMerge(shallowMerge) {
    return (schemaDef) => transformSchemaDefinition(schemaDef, (def) => {
        if (typeof def === "boolean" || def.allOf === undefined) {
            return def;
        }
        return shallowMerge(def);
    });
}
//# sourceMappingURL=all-of-merge.js.map